import { Button as DefaultButton } from "@mui/material";
import DownloadIcon from "@mui/icons-material/Download";

type DownloadButtonProps = {
	disabled?: boolean;
	disableElevation?: boolean;
	disableFocusRipple?: boolean;
	disableRipple?: boolean;
	size?: number;
	onClick?: () => void;
	sx?: object;
	content: string;
	className?: string;
};
export default function DownloadButton(props: Readonly<DownloadButtonProps>) {
	const {
		disabled = false,
		disableElevation = false,
		disableFocusRipple = false,
		disableRipple = false,
		size = 20,
		onClick,
		sx,
		content,
		className = "",
	} = props;
	return (
		<DefaultButton
			disabled={disabled}
			onClick={onClick}
			className={className}
			disableElevation={disableElevation}
			disableFocusRipple={disableFocusRipple}
			disableRipple={disableRipple}
			sx={{
				...sx,
				color: "var(--text-color)",
				textTransform: "none",
				fontFamily: "var(--font-family-v2)",
			}}
			startIcon={
				<DownloadIcon
					sx={{
						"&.MuiSvgIcon-root": {
							fontSize: `${size}px`,
						},
					}}
				/>
			}
		>
			{content}
		</DefaultButton>
	);
}
